<template>
  <div class="Acotseup">
    <div class="setup-background">
      <div class="NewCape-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        账户设置
      </div>
      <!-- <router-link :to="{path: 'Nickment'}">
        <div class="setup-category setup-distance">昵称</div>
      </router-link> -->
      <div class="setup-category setup-distance" @click="acotreon()">实名认证</div>
      <!-- <router-link :to="{path: 'Mobiment'}">
        <div class="setup-category setup-horine">手机号</div>
      </router-link> -->
      <div class="setup-acndelot" @click="accaon()">销户</div>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + acotfail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{acottips}}</p>
      </div>
    </div>
    <!-- 成功提示 -->
    <div id="toast" :style="'display:' + acotsucs">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{acottips}}</p>
      </div>
    </div>
    <!-- 提示语 -->
    <div class="js_dialog" id="iosDialog1" :style="'display:' + acothint">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd" style="padding: 0;"><strong class="weui-dialog__title">账户注销后,将放弃以下资产和权益</strong></div>
        <div class="weui-dialog__bd" style="text-align: left;">
          1、身份账号信息将清空且无法恢复<br>
          2、银行卡的快捷支付服务将自动关闭<br>
          3、交易记录将被删除<br>
          4、卡包中所有绑卡将被清空,请确保所有交易已经完结且无纠纷账户删除后历史交易可能产生的资金退回权益将被视为自动放弃
        </div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_default" @click="acotcane()">取消</a>
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" style="color: #f10100" @click="acotconf()">确定</a>
        </div>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      acothint: 'none',
      loginID: '',
      acotfail: 'none',
      acottips: '',
      acotsucs: 'none'
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
  },
  mounted () {

  },
  methods: {
    // 点击实名认证触发
    acotreon(){
      this.$axios.post('app/appUserOldCardPackage',this.$qs.stringify({
        token: this.loginID
      }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        if(res.data.code == '200'){
          if(res.data.data[0].realname == '' || res.data.data[0].identity == ''){
            this.acottips = '您没有进行实名认证';
            this.acotfail = 'block';
            const _this = this;
            setTimeout(function(){
              _this.acotfail = 'none';
            },1200)
          }else{
            this.$router.push({name: 'realtion'});
          }
        }else{
          this.acottips = res.data.msg;
          this.acotfail = 'block';
          const _this = this;
          setTimeout(function(){
            _this.acotfail = 'none';
          },1200)
        }
      })
      .catch(() => {
        console.log('获取失败');
      });
    },
    // 点击触发销户
    accaon(){
      this.acothint = 'block';
    },
    // 点击取消触发
    acotcane(){
      this.acothint = 'none';
    },
    // 点击确认触发
    acotconf(){
      this.acothint = 'none';
      this.$axios.post('app/deleteuserinfoByApp',this.$qs.stringify({
        token: this.loginID
      }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        if(res.data.code == '200'){
          this.acottips = res.data.msg;
          this.acotsucs = 'block';
          const _this = this;
          setTimeout(function(){
            localStorage.removeItem("usertoken");
            _this.acotsucs = 'none';
            _this.$router.push({name: 'signin'});
          },1200)
        }else{
          this.acottips = res.data.msg;
          this.acotfail = 'block';
          const _this = this;
          setTimeout(function(){
            _this.acotfail = 'none';
          },1200)
        }
      })
      .catch(() => {
        console.log('获取失败');
      });
    },
    // 返回上一层
    BackLevel(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  @import "obraocs/setup.css";
</style>